import { render, staticRenderFns } from "./ProductYouMayLike.vue?vue&type=template&id=03203c6b&scoped=true&"
import script from "./ProductYouMayLike.vue?vue&type=script&lang=js&"
export * from "./ProductYouMayLike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03203c6b",
  null
  
)

export default component.exports